<div class="choice-group" [id]="'choice-group-' + choice.id" *ngFor="let choice of choices">
    <div class="choice-header d-column">
      <div class="d-flex space-between align-items-center w-100">
        <div class="choice-header-content">
          <h3 class="label-medium-medium">
            {{ choice.name }}
          </h3>
          <p class="label-regular-tiny">
            {{ getChoiceSubtitle(choice) }}
          </p>
          <!-- <mnt-icon icon="info" size="tiny"></mnt-icon> Ao selecionar as opções, será cobrado o valor da opção mais cara dentre as escolhidas
          <p
            *ngIf="choice.use_greater_option_price === 1"
            class="label-regular-tiny text-color-subtitle mt-1"
          > -->
          <!-- <yoo-icon icon="info" size="small"></yoo-icon> Ao selecionar as opções, será cobrado o valor da opção mais cara dentre as escolhidas -->
        </div>
        <div class="choice-header-badges">
          <mnt-badge
            *ngIf="choice.required === 1"
            label="Obrigatório"
            color="primary"
            variant="regular"
            size="tiny"
            tone="highlight"
          ></mnt-badge>

          <mnt-icon
            *ngIf="isMaxQuantitySelected()"
            icon="check"
            size="small"
            color="#16653C"
            [background]="['#BBF7D6', 'circle']"
          ></mnt-icon>
        </div>
      </div>
      <div
        *ngIf="choice.use_greater_option_price === 1 && choice.max > 1 && moduloMaiorValorComplemento"
        class="d-flex align-items-center gap-1 mt-1"
      >
        <mnt-icon icon="info" size="small" color="#5F676C"></mnt-icon>
        <p class="label-regular-tiny text-color-subtitle">
          Ao selecionar as opções, será cobrado o valor da opção mais cara dentre as escolhidas
        </p>
      </div>
    </div>

    <div class="choice-options-list">
      <div class="option-item" *ngFor="let option of choice.options">
        <div class="option-item-wrapper" (click)="onOptionClick(choice, option)">
          <ng-container *ngIf="!option.img">
            <mnt-icon
              class="option-item-image"
              icon="image"
              size="28"
              color="#4B5053"
              [background]="['#E5E7E8', 'rounded']"
            ></mnt-icon>
          </ng-container>

          <img
            class="option-item-image"
            *ngIf="option.img"
            [src]="option.img"
            [alt]="option.name"
          />

          <div class="option-item-content">
            <span class="label-regular-small text-color-title">
              {{ option.name }}
            </span>
            <p class="body-small text-color-subtitle" *ngIf="option.description">
              {{ option.description }}
            </p>
            <!-- Price adjusted: show original strikethrough and new price in green -->
            <span *ngIf="isPriceAdjusted(choice, option)" class="label-regular-tiny">
              <span style="text-decoration: line-through; color: #9CA3AF;">
                + {{ option.price | currency }}
              </span>
              <span style="color: #5db781; margin-left: 4px;">
                + {{ getDisplayPrice(choice, option) | currency }}
              </span>
            </span>

            <!-- Normal price display -->
            <span
              *ngIf="!isPriceAdjusted(choice, option) && getDisplayPrice(choice, option) > 0"
              class="label-regular-tiny text-color-subtitle"
            >
              + {{ getDisplayPrice(choice, option) | currency }}
            </span>
          </div>

          <ng-container *ngIf="choice.max > 1">
            <div class="option-item-actions ml-auto" (click)="$event.stopPropagation()">
              <mnt-button-icon
                *ngIf="!isOptionSelected(option)"
                [disabled]="isOptionDisabled(choice)"
                icon="plus"
                variant="plain"
                color="primary"
                size="small"
                (buttonClick)="onQuantityChange(choice, option, 1)"
              ></mnt-button-icon>

              <mnt-field-number
                *ngIf="isOptionSelected(option)"
                [inputName]="'option-quantity-' + choice.id + '-' + option.id"
                size="small"
                variant="plain"
                [value]="getOptionQuantity(option)"
                [min]="0"
                [max]="getRemainingQuantity(choice, option.id)"
                (change)="onQuantityChange(choice, option, $any($event).detail.value)"
              ></mnt-field-number>
            </div>
          </ng-container>

          <ng-container *ngIf="choice.max === 1">
            <div
              class="custom-radio"
              [class.checked]="isOptionSelected(option)"
            ></div>
            <!-- <input
              type="radio"
              [name]="'option-radio-' + choice.id"
              [id]="'option-radio-' + choice.id + '-' + option.id"
              [checked]="isOptionSelected(option)"
              (click)="$event.stopPropagation(); $event.preventDefault();"
              readonly
            > -->
          </ng-container>
        </div>
      </div>
    </div>
  </div>